
import nieuweSportclubApi from "../../../api/nieuweSportclubApi";
import assign from 'object-assign';
import mergeDeep from "../../../util/mergeDeep.js";

export default class IdentificatiePageHelper {

    constructor(context, redirector) {
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        let context = this.context;
        context.props.loadLayout("Meld nieuwe sportclub");

        context.setState({
            model: context.props.storeModel
        });
    }

    goToNext() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        ajaxActions.started();
        return nieuweSportclubApi.validateIdentificatie(mergeDeep({}, context.state.model))
            .then((response) => {
                ajaxActions.ended();
                if (!response.data.hasValidationErrors) {
                    this.redirector.goTo("/nieuweSportclub/adres");
                }
                else {
                    context.setState({
                        errors: assign({}, response.data.validationResults)
                    });
                }
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }

    change(event) {
        const value = event.target.value;
        const property = event.target.name;

        const model = mergeDeep({}, this.context.state.model);
        model[property] = value;

        if (property === "isAangeslotenBijSportfederatie" && value === "false") {
            model["naamSportfederatie"] = "";
        }

        this.context.setState({
            model,
            datumOprichtingHasFocus: false
        });
    }

    goToPrev() {
        const context = this.context;
        const ajaxActions = context.props.ajaxActions;
        ajaxActions.started();
        return nieuweSportclubApi.validateIdentificatie(mergeDeep({}, context.state.model))
            .then((response) => {
                ajaxActions.ended();
                if (!response.data.hasValidationErrors) {
                    this.redirector.goTo("/nieuweSportclub/organisatie");
                }
                else {
                    context.setState({
                        errors: assign({}, response.data.validationResults)
                    });
                }
            })
            .catch((ex) => {
                ajaxActions.failed();
                context.props.throwException(ex);
            });
    }
}